import { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';

interface BasicOperatorItemProps {
  text: string;
}

export function BasicOperatorItem({ text }: BasicOperatorItemProps) {
  const colors = useContext(ColorThemeContext);
  return (
    <View padding={1}>
      <MBTextBody1 color={colors.foregroundActive}>{text}</MBTextBody1>
    </View>
  );
}
